import React, { useState } from "react"
import PropTypes from "prop-types"
import { Form } from "antd"
import { CreditCardOutlined } from "@ant-design/icons"
import { CardNumberElement, useStripe, useElements } from "@stripe/react-stripe-js"
import StripeWrapper from "components/stripe/StripeWrapper"
import AddCardModal from "pagesV2/pro/Bookings/BookingForm/AddCardModal"
import { toaster } from "components/common/Toast"
import styles from "./ChatBox.module.css"

const AddCardInner = ({ onSubmitted, disabled }) => {
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async () => {
    let formData
    try {
      formData = await form.validateFields()
    } catch {
      return
    }

    if (!stripe || !elements) return
    const cardNumberElement = elements.getElement(CardNumberElement)
    if (!cardNumberElement) return

    setLoading(true)
    try {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name: formData.cardHolderName,
          address: { postal_code: formData.zip }
        }
      })

      if (error) {
        toaster.error(error.message || "Unable to add card. Please try again.")
        return
      }

      setVisible(false)
      form.resetFields()
      await onSubmitted(paymentMethod.id)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button className={styles.fileUploadTrigger} disabled={disabled} onClick={() => setVisible(true)}>
        <CreditCardOutlined />
        <span>Add a card</span>
      </button>
      <AddCardModal visible={visible} onCancel={() => setVisible(false)} onSubmit={handleSubmit} form={form} loading={loading} />
    </>
  )
}

AddCardInner.propTypes = {
  onSubmitted: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

const AddCardSection = (props) => (
  <StripeWrapper>
    <AddCardInner {...props} />
  </StripeWrapper>
)

export default AddCardSection
